import { render, staticRenderFns } from "./courseHome.vue?vue&type=template&id=8c3b8f5a&scoped=true&"
import script from "./courseHome.vue?vue&type=script&lang=js&"
export * from "./courseHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3b8f5a",
  null
  
)

export default component.exports